"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationSound = exports.NotificationValue = exports.NotificationPlatform = void 0;
var NotificationPlatform;
(function (NotificationPlatform) {
  NotificationPlatform["EMAIL_NOTIFICATION"] = "humane-notifications-email";
  NotificationPlatform["SOUND_SETTING"] = "humane-notifications-browser-sound";
  NotificationPlatform["ABM"] = "follow_accounts";
})(NotificationPlatform = exports.NotificationPlatform || (exports.NotificationPlatform = {}));
var NotificationValue;
(function (NotificationValue) {
  // humane notification expect a value of the following: all, mine, mine-and-unassigned, nothing
  // however, the only two options we support in the desktop app right now are on and off
  NotificationValue["MINE"] = "mine";
  NotificationValue["MINE_AND_UNASSIGNED"] = "mine-and-unassigned";
  NotificationValue["ALL"] = "all";
  NotificationValue["OFF"] = "nothing";
})(NotificationValue = exports.NotificationValue || (exports.NotificationValue = {}));
var NotificationSound;
(function (NotificationSound) {
  NotificationSound["DING"] = "ding";
  NotificationSound["CLICK"] = "click";
  NotificationSound["GLOSSY"] = "glossy";
  NotificationSound["POP"] = "pop";
  NotificationSound["XYLOPHONE"] = "xylophone";
  NotificationSound["NONE"] = "none";
})(NotificationSound = exports.NotificationSound || (exports.NotificationSound = {}));